import { Injectable } from "@angular/core";
import { ApiRequestDispatcherService } from "apps-module/app/shared-library/services/api/api-request-dispatcher.service";
import { Observable } from "rxjs";

import { FormSearchParametersModel } from "../models/form-search-parameters.model";
import { SearchResultModel } from "../models/search-result.model";

@Injectable()
export class SearchService {
    public constructor(
        private _requestDispatcher: ApiRequestDispatcherService
    ) {
    }

    public search(searchParams: FormSearchParametersModel): Observable<SearchResultModel> {
        return this._requestDispatcher.get<SearchResultModel>("/api/vacancies-search/results",  {...searchParams});
    }
}
